function _assertThisInitialized(e) {
    if (void 0 === e)
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports['default'] = module.exports;